export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8377.cb8b44b9.jpg";